module.exports = __webpack_public_path__ + "static/media/ES-Udg.a7d95e16.png";